import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { ReportingHome } from "components/Reports";

const Cnt_Reports: React.FC<any> = (props) => {
  return <ReportingHome/>
};

export default withRouter(Cnt_Reports);
